import React, { useCallback } from "react";
import FetchHook from "../../Api/FetchHooks";
import { useState } from "react";
import { useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import PageLoader from "../../Components/PageLoader";
import TableComponent from "../../Components/TableComponent";
import moment from "moment";
import AddIcon from "@mui/icons-material/Add";
import AlertComponent from "../../Components/AlertComponent";
import Page from "../../Components/Page";
import ActionDialog from "../../Components/ActionDialog";
import { useSelector } from "react-redux";
import UseServerTable from "../../Hooks/UseServerTable";
import { set } from "react-hook-form";
import ErrorDisplay from "../../Components/ErrorDisplay";
import { AllInbox } from "@mui/icons-material";
import { formatCurrencyV2, formatDate, getKycChip } from "../../utils/helpers";

const PoolBasket = ({ showHeader }) => {
  const loggedInUser = useSelector((state) => state.auth.user);

  const [user, setUser] = useState(loggedInUser);
  const [status, setStatus] = useState("active");
  const [data, setData] = useState([]);
  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const [loading, response, request] = FetchHook();

  // const fetchPoolBaskets = useCallback(() => {
  //   request({
  //     url: `/pool_basket?status=${status}`,
  //   });
  // }, [status]);

  // useEffect(() => {
  //   fetchPoolBaskets();
  // }, [fetchPoolBaskets]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl:
      status != null && status != ""
        ? `/pool_basket?status=${status}`
        : `/pool_basket`,
    onSuccess: (data) => {
      setData(data.Data);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    {
      field: "id",
      headerName: "#",
      width: 150,
    },
    {
      field: "entity_id",
      headerName: "Owner",
      width: 180,
    },
    {
      field: "name",
      headerName: "Pool Name",
      width: 150,
    },
    {
      field: "members",
      headerName: "Members",
      width: 120,
    },
    {
      field: "contributions",
      headerName: "Contributions",
      width: 150,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "balance",
      headerName: "Balance",
      width: 120,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "interest_earned",
      headerName: "Interest Earned",
      width: 120,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "status",
      headerName: "Status",
      width: 120,
      renderCell: (params) => getKycChip(params?.value),
    },
    {
      field: "date_created",
      headerName: "Date Created",
      width: 200,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "last_updated_on",
      headerName: "Date Updated",
      width: 200,
      valueFormatter: (params) => formatDate(params?.value),
    },
  ];

  return (
    <Page
      title={"Pool Baskets"}
      actions={
        <Box>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => {
              openDialog("create_basket", "Create Pool Basket");
            }}
          >
            Create Basket
          </Button>
        </Box>
      }
    >
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <ActionDialog
        open={dialog.open}
        onClose={closeDialog}
        dialogType={dialog.type}
        dialogLabel={dialog.label}
        user={user}
        onSuccess={refresh}
      />

      <Card>
        <CardHeader
          title={
            <>
              {showHeader === false && (
                <Typography variant="h6">User Loan Requests</Typography>
              )}
            </>
          }
          action={
            <FormControl sx={{ width: "200px" }}>
              <InputLabel id="status" size="small">
                Status
              </InputLabel>

              <Select
                labelId="status"
                id="status"
                value={status}
                label="status"
                onChange={(e) => {
                  setStatus(e.target.value);
                }}
                size="small"
              >
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
                <MenuItem value="domant">Dormant</MenuItem>
                <MenuItem value="suspended">Suspended</MenuItem>
                <MenuItem value="closed">Closed</MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="cancelled">Cancelled</MenuItem>
                <MenuItem value="incomplete">Incomplete</MenuItem>
                <MenuItem value="complete">Complete</MenuItem>
              </Select>
            </FormControl>
          }
        />
        <CardContent>
          {gridProps.loading ? (
            <PageLoader />
          ) : data && data.length > 0 ? (
            <TableComponent
              data={data}
              columns={columns}
              sortModel={[
                {
                  field: "date_created",
                  sort: "desc",
                },
              ]}
              {...gridProps}
            />
          ) : (
            <ErrorDisplay
              message="No recent data"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default PoolBasket;
